import PermissionError from './permission-error';

export default PermissionError;
